import { TARGETS } from '../../../pages/vehicle/[vehicleId]'
import { Button } from '../../../components/button'
import Modal from '../../../components/modal'
import MembershipInfoInBuyAgreement from './membershipInfo-in-agreement'

export default function BuyFeeAgreement({
  onClose,
  onAccept,
  target,
  buyFee,
  shipmentRate,
  isDealerVehicle,
}) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <h3>
          {target === TARGETS.Offer
            ? 'Buy Agreement'
            : target === TARGETS.BuyNow
            ? 'Buy It Now Agreement'
            : 'Buy Agreement'}
        </h3>
        <p>
          {target === TARGETS.Offer
            ? 'By placing this offer you agree to the following fees that will be added to the vehicle total should your offer be accepted'
            : target === TARGETS.BuyNow
            ? 'By buying this vehicle you agree to the following fees that will be added to the vehicle total'
            : 'By placing this bid you agree to the following fees that will be added to the vehicle total should you be the winning bidder.'}
        </p>
        <div className='tableContainer'>
          <table>
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Service Fee</td>
                <td>{`$${buyFee}`}</td>
              </tr>
              {!!shipmentRate && shipmentRate.isSucceeded && (
                <tr>
                  <td>
                    Estimated Shipping Fee*
                    <br />
                    <div className='asterixExplanation'>*FREE pickup available</div>
                  </td>
                  <td>{`$${shipmentRate.rate}`}</td>
                </tr>
              )}
            </tbody>
          </table>
          {!!shipmentRate && !shipmentRate.isSucceeded && (
            <div className='shippingRateError'>
              <span>
                Shipping rate will be calculated and included in the total cost. If a shipping fee
                is not shown above, please contact support for an estimate:{' '}
              </span>
              <a className='mail' href='mailto:support@drivrzxchange.com'>
                support@drivrzxchange.com
              </a>
            </div>
          )}
          {isDealerVehicle && <MembershipInfoInBuyAgreement />}
        </div>
        <Button onClick={onAccept}>Accept</Button>
      </div>

      <style jsx>{`
        .wrapper {
          max-width: 100vw;
          width: 43.6rem;
          padding: 2.8rem 2rem 3.2rem;
          background: #fff;
          border-radius: 1rem;

          h3 {
            text-align: center;
            font-size: 3.6rem;
          }

          p {
            margin: 1.2rem 0;
            text-align: center;
            line-height: 2rem;
            font-size: 1.6rem;
          }
        }

        .asterixExplanation {
          color: red;
          font-size: small;
        }

        .tableContainer {
          width: 100%;
          overflow: auto;
          margin: 0 0 2.2rem;
          font-size: 1.6rem;

          table {
            width: 100%;
            border-collapse: collapse;

            th {
              border-bottom: 0.2rem solid var(--separator-line-color);
            }

            td {
              border-bottom: 0.1rem solid var(--separator-line-color);
            }

            th,
            td {
              text-align: left;
              align-items: left;
              padding: 1.8rem 0rem;
            }
          }
        }

        .shippingRateError {
          margin-top: 1.8rem;
          text-align: center;

          a {
            color: var(--primary-color);
          }
        }
      `}</style>
    </Modal>
  )
}
